import { InternalEvent } from '../../enums';
import {
  InternalEventPayloadByEvent,
  InternalEventPayloadValidator,
} from '../../types';
import {
  internalAddToCartPayloadValidator,
  internalDialogClosePayloadValidator,
  internalDialogOpenPayloadValidator,
} from './validators';
import { internalDialogPrefetchPayloadValidator } from './validators/dialog-prefetch';

export const isInternalEventPayload = <Event extends InternalEvent>(
  event: Event,
  payload: InternalEventPayloadByEvent[Event] | unknown
): payload is InternalEventPayloadByEvent[Event] => {
  const validator = internalEventPayloadValidators[event];
  return validator(payload);
};

const internalEventPayloadValidators: {
  [Event in InternalEvent]: InternalEventPayloadValidator<Event>;
} = {
  [InternalEvent.ADD_TO_CART]: internalAddToCartPayloadValidator,
  [InternalEvent.DIALOG_CLOSE]: internalDialogClosePayloadValidator,
  [InternalEvent.DIALOG_OPEN]: internalDialogOpenPayloadValidator,
  [InternalEvent.DIALOG_PREFETCH]: internalDialogPrefetchPayloadValidator,
};
